import Component from '../inherited/Component'

export default class QuantitySelector extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this.input = this._elem.querySelector('[data-quantity-selector-input]')
    this.minus = this._elem.querySelector('[data-quantity-selector-minus]')
    this.plus = this._elem.querySelector('[data-quantity-selector-plus]')
  }

  mount() {
    if(this.minus) {
      this.minus.addEventListener('click', this.decreaseQuantity.bind(this))
    }
    if(this.plus) {
      this.plus.addEventListener('click', this.increaseQuantity.bind(this))
    }
    if(this._options.toggle) {
      this._elem.addEventListener('click', this.toggleQuantity.bind(this))
    }
  }

  increaseQuantity() {
    this.input.value = parseInt(this.input.value) + 1
  }

  decreaseQuantity() {
    if (parseInt(this.input.value) > 1) {
      this.input.value = parseInt(this.input.value) - 1
    }
  }

  toggleQuantity() {
    if (parseInt(this.input.value) >= 1) {
      this.input.value = 0
    } else {
      this.input.value = 1
    }
  }
}
